import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const SAFETY_COMMON_LANG: {
  SAFETY_COMMON_PAGE_MOVEMENT_DETECTION_ALERT_MESSAGE: MvnCodeFE;
  SAFETY_COMMON_AUDIT_TRAIL_SYSTEM_ADMIN_ACTANT: MvnCodeFE;
} = {
  SAFETY_COMMON_PAGE_MOVEMENT_DETECTION_ALERT_MESSAGE: {
    ko: "저장되지 않은 자료가 있습니다. 페이지를 이동 하시겠습니까?",
    en: "You have unsaved data. Do you want to move the page?",
  },
  SAFETY_COMMON_AUDIT_TRAIL_SYSTEM_ADMIN_ACTANT: {
    ko: "System Admin",
    en: "System Admin",
  },
};

MvnCodeInitiate(SAFETY_COMMON_LANG);
